// @flow
import Select from './Select'
import { createFormGroupField } from '@src/components/ui/FormGroup'

export default createFormGroupField(Select)
